<form [formGroup]="form" autocomplete="off" class="form-horizontal">

  <!-- VORAUSSICHTLICHE LOHNSTEUER -->
  <div class="mb-5x">
    <h3>{{ this.titel }}</h3>

    <div class="col-sm-12 col-lg-12 p-0 mb-3x mt-2x">
      <common-ui-card [message]="this.hinweis" type="info"></common-ui-card>
    </div>
    <div class="form-row">
      <label class="col-sm-8 col-form-label" for="voraussichtlicheLohnsteuer">
        {{ this.voraussichtlicheLohnsteuer }}
      </label>
      <div class="col-sm-4">
        <input class="form-control text-right pr-3x" datevMessagePath="voraussichtlicheLohnsteuer{{objectId}}"
               formControlName="voraussichtlicheLohnsteuer" id="voraussichtlicheLohnsteuer"
               type="text" numeric transformNumber utilsCheckValidity
               utilsControlState utilsMarkRequired
               utilsValidationMessage/>
        <em class="icon-euro icon-euro-padding"></em>
      </div>
    </div>
  </div>

</form>


